export interface Instructor {
    user_name: string;
    email: string | null;
}

export interface InstructorWithEmail extends Instructor {
    email: string;
}

export interface ClassSessionWithInstructors {
    class_session_uuid: string;
    class_session_topic: string;
    meeting_id: string;
    starting_at?: string;
    ending_at?: string;
    instructors: Instructor[];
}

export enum Status {
    INITIAL = 'INITIAL',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}

export interface Statuses {
    fetchClassSessions: Status;
}

export interface Option {
    label: string;
    email: string;
}

export enum DirectionOption {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
}

export type Direction = undefined | DirectionOption;

export enum SortOption {
    NAME = 'NAME',
    INSTRUCTOR = 'INSTRUCTOR',
    DATES = 'DATES'
}

export type SortBy = undefined | SortOption;

// generated from https://app.quicktype.io/
//class session Users
export type ClassSessionUser = {
    zoomstate_id: null;
    meeting_zoom_id: string;
    zoomstate_uuid: string;
    meeting_id: string;
    zoom_id: string;
    is_host: boolean;
    user_name: string | null;
    is_talking: null;
    is_video_on: null;
    is_audio_muted: null;
    raised_hand: null;
    feedback: null;
    raised_hand_time: null;
    feedback_time: null;
    presenting: null;
    focused: null;
    focused_time: null;
    stars: null;
    breakout_id: string;
    spotlight: null;
    reaction: null;
    reaction_time: null;
    talk_time: null;
    join_time: string;
    fake: null;
    random_value: number;
    presentation: null;
    apptype: Apptype | string;
    identifystatus: null;
    validated: null;
    is_owner: boolean;
    temp_role: string;
    is_recording: null;
    device: Device;
    zoomstate_student_id: string;
    history_timestamp: string;
    delete_reason: null;
    zoom_login_id: null;
    row_crtd: Date;
    is_talking_updtd: null;
    is_video_on_updtd: null;
    is_audio_muted_updtd: null;
    raised_hand_updtd: null;
    spotlight_updtd: null;
    focused_updtd: null;
    feedback_updtd: null;
    reaction_updtd: null;
    presenting_updtd: null;
    stars_updtd: null;
    visibility_mode: string;
    persistent_id: string;
    extra: Extra;
    ds_id: string;
    created_at: Date;
    updated_at: Date;
    reportingEvents: ReportingEvent[];
    persistent_session_id: null;
};

export enum Apptype {
    Classforteams = 'classforteams'
}

export type Device = {
    os?: string;
    build?: number;
    system?: string;
    browser?: string;
    version?: string;
    device_type?: string;
};

export type Extra = {
    engagement: Engagement;
};

export type Engagement = {
    events: Events;
    endTime: number;
    talkTime: number;
    starCount: number;
    startTime: number;
    wordCount: number;
    unmuteTime: number;
    focusedTime: number;
    videoOnTime: number;
    feedbackCount: number;
    reactionCount: number;
    zoomStateUuid: string;
    attendanceTime: number;
    feedbackDetails: Details;
    publicChatCount: number;
    raisedHandCount: number;
    reactionDetails: Details;
    privateChatCount: number;
    screenSharingTime: number;
};

export type Events = {
    talk?: Array<boolean | number | null>;
    focus: Array<number | null | string>;
    unmute: Array<boolean | number | null>;
    videoOn?: Array<boolean | number | null>;
    publicChat?: number[];
    privateChat?: number[];
};

export type Details = {};

export type ReportingEvent = {
    zoomstate_uuid: string;
    meeting_id: string;
    breakout_id: string;
    zoomstate_student_id: string;
    event_start: Date;
    event_end: Date;
    event_duration: number;
    event_type: EventType;
    event_value: string;
    persistent_id: string;
    start_timestamp: string;
    end_timestamp: string;
};

export enum EventType {
    Attendance = 'ATTENDANCE',
    Feedback = 'FEEDBACK',
    IsAudioMuted = 'IS_AUDIO_MUTED',
    IsTalking = 'IS_TALKING',
    IsVideoOn = 'IS_VIDEO_ON',
    Presenting = 'PRESENTING',
    PrivateChat = 'PRIVATE_CHAT',
    ProctorStatus = 'PROCTOR_STATUS',
    PublicChat = 'PUBLIC_CHAT',
    RaisedHand = 'RAISED_HAND',
    Reaction = 'REACTION',
    ScreenSharing = 'SCREEN_SHARING',
    Spotlight = 'SPOTLIGHT',
    Stars = 'STARS',
    TabOpened = 'TAB_OPENED',
    TempRole = 'TEMP_ROLE',
    UserName = 'USER_NAME',
    ZoomstateStudentID = 'ZOOMSTATE_STUDENT_ID'
}
